import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { XferOperationStatus } from '../../../shared/models/xfer.model';
import { StatusChipType } from '../status-chip/status-chip.enums';

@Component({
  host: { 'test-id': 'operation-status' },
  selector: 'operation-status',
  styleUrls: ['./operation-status.component.scss'],
  templateUrl: './operation-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationStatusComponent implements OnChanges {
  @Input() status: XferOperationStatus;

  protected readonly statuses = XferOperationStatus;

  protected statusTooltip: string;
  protected chipStatus: StatusChipType;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.status?.currentValue) {
      this.chipStatus = this.getChipStatus(this.status);
      this.statusTooltip = this.getStatusTooltip(this.status);
    }
  }

  private getChipStatus(status: XferOperationStatus): StatusChipType {
    switch (status) {
      case XferOperationStatus.Completed:
        return StatusChipType.Completed;
      case XferOperationStatus.Cancelled:
      case XferOperationStatus.Cancelling:
        return StatusChipType.Cancelled;
      case XferOperationStatus.Failed:
        return StatusChipType.Failed;
      default:
        return StatusChipType.Sync;
    }
  }

  private getStatusTooltip(status: XferOperationStatus): string {
    const prefix = 'operationsStatuses.';

    switch (status) {
      case XferOperationStatus.Completed:
        return `${prefix}completed`;
      case XferOperationStatus.Cancelled:
        return `${prefix}cancelled`;
      case XferOperationStatus.Cancelling:
        return `${prefix}cancelling`;
      case XferOperationStatus.Pending:
        return `${prefix}pending`;
      case XferOperationStatus.Failed:
        return `${prefix}failed`;
      default:
        return `${prefix}running`;
    }
  }
}

